// extracted by mini-css-extract-plugin
export default {"contatiner":"VideoDetail_contatiner__SyXda","grid":"VideoDetail_grid__MyrFN"};